export const defaultNavigationConfig = undefined;

//# sourceMappingURL=defaultConfig.js.map